import * as XLSX from "xlsx-js-style";

export const QUILTER_TEMPLATE_HEADERS = [
  "Adviser Name", "Account Name", "Client", "PolicyNo", "Supplier", "Type", "Product",
  "Total", "Gross", "Payment Amount", "Profit", "Main Revenue Type", "Basis", "Paid Date", "Postcode",
];

export const SUSPENSE_TEMPLATE_HEADERS = [
  "ADVISER", "DATE", "CLIENT", "POLICY NUMBER", "PAYER", "SUSPENSE AMOUNT", "SUSPENSE CHARGE",
];

export const downloadStatementTemplate = ({
  headers,
  fileName,
  sheetName,
  matchFciStyle = false,
  dateHeaders = [],
}) => {
  const worksheet = XLSX.utils.aoa_to_sheet([headers]);
  worksheet["!cols"] = headers.map((header) => ({
    wch: Math.max(18, header.length + 2),
  }));
  if (matchFciStyle) {
    worksheet["!autofilter"] = {
      ref: XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: { r: 0, c: Math.max(headers.length - 1, 0) },
      }),
    };
    headers.forEach((_, columnIndex) => {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: columnIndex })];
      if (!cell) return;
      cell.s = {
        fill: { fgColor: { rgb: "081E56" } },
        font: { color: { rgb: "FFFFFF" }, bold: true },
        alignment: { vertical: "center", wrapText: true },
      };
    });
    worksheet["!rows"] = [{ hpt: 30 }];
  }
  dateHeaders.forEach((dateHeader) => {
    const columnIndex = headers.indexOf(dateHeader);
    if (columnIndex < 0) return;
    const address = XLSX.utils.encode_cell({ r: 1, c: columnIndex });
    worksheet[address] = {
      t: "n",
      v: null,
      z: "dd mmm yy",
      s: { numFmt: "dd mmm yy" },
    };
    worksheet["!ref"] = XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: 1, c: Math.max(headers.length - 1, 0) },
    });
  });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
};
